var React = require('react');

function Ground (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1600 75.7618C1600 75.7618 1600 75.7618 1192.5 75.7618C389.202 75.7618 211.5 75.7617 211.5 75.7617L0 75.7618V31.2618C263.132 -7.624 763.978 0.761369 1256.5 0.761369C1374.83 0.761369 1489.86 2.22837 1600 4.99676C1600 4.99676 1600 4.65153 1600 75.7618Z","fill":"white"}));
}

Ground.defaultProps = {"viewBox":"0 0 1600 75","fill":"none","preserveAspectRatio":"none"};

module.exports = Ground;

Ground.default = Ground;
